import SummaryView from './SummaryView.vue';

export default SummaryView;
